<template>
    <div>
        <div class="desktop">
            <div class="ui fluid container to-move" style="background-color: black !important; height: 100vh">
                <div class="ui stackable grid" style="background-color: white !important; height: 100vh; margin 0px !important; padding: 0px !important">
                    <div class="eight wide column" style="background-color: white !important; height: 100vh">
                      <div class="ui middle aligned grid" style="height: 100vh; padding: 25px">
                          <div class="column">
                            <div class="ui container">
                                <div class="ui stackable grid">
                                    <div class="three wide column"></div>
                                    <div class="ten wide column">
                                        <h1 class="MainPageFont">  {{ $t("404.title") }} </h1>
                                        <h2>  {{ $t("404.desc") }} </h2>
                                    </div>
                                    <div class="three wide column">
                                    </div>
                                </div>
                            </div> 
                          </div>
                      </div>
                    </div>
                    <div class="eight wide column" style="height: 100vh">
                        <div class="where-background"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mobile">
            <div class="ui container" style="padding-top: 20px">
                <div class="ui middle aligned grid" style="height: 100vh; padding: 25px">
                    <div class="column">
                        <h1 class="animated fadeInRightBig MainPageFont dark-prom" >  {{ $t("404.title") }} </h1>
                        <h2 class="animated fadeInLeftBig dark-prom">  {{ $t("404.desc") }} </h2>
                        <br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

const $ = require('jquery')
window.$ = $

export default {
    name: 'P404',
    props: [],
    data: function () {
        return {

        }
    },
    components: {
        
    },
    methods: {},
    beforeMount: function () {

    },
    mounted: function () {
        
    },
    beforeDestroy: function () {
        this.$bus.$emit('breadcrumb')
    }
}
</script>

<style>
.where-background {
    -webkit-background-size: cover;
    -moz-background-size: cover;
    background-size: cover;
    -o-background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: white;
    background-image: url('/img/backgrounds/DSCF1612.jpg');
    padding: 25px;
    min-height: 100vh;
}

</style>
